/*
 *
 * DashboardSecuritySettings action/reducer
 *
 */

import { createAction, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { push } from "connected-react-router";
import { PasswordPolicyResponse } from "types/PasswordPolicy";
import { createActionDispatchers } from "utils/reduxHelpers";
import { ApiPasswordError } from "./types";
import { getTnCForCidpUser, setUserAcceptedNewTnC } from "scenes/redux";

export type State = {
  loadingPasswordPolicies: boolean;
  passwordPolicies: any;
  submitting: boolean;
  passwordUpdated: boolean;
  apiPasswordError: ApiPasswordError;
};

export const initialState: State = {
  loadingPasswordPolicies: false,
  passwordPolicies: {
    complexity: {},
    age: {},
    lockout: {},
  },
  submitting: false,
  passwordUpdated: false,
  apiPasswordError: null,
};

const slice = createSlice({
  name: "editPassword",
  initialState,
  // create actions with reducer (slice action) here
  reducers: {
    loadPasswordPolicies(state: State) {
      state.loadingPasswordPolicies = true;
    },
    afterPasswordPoliciesLoad(
      state: State,
      action: PayloadAction<PasswordPolicyResponse>
    ) {
      return {
        ...state,
        loadingPasswordPolicies: false,
        passwordPolicies: {
          ...action.payload.settings.password,
        },
      };
    },
    submitChangePassword(state: State) {
      state.submitting = true;
    },
    afterApiPasswordError(
      state: State,
      action: PayloadAction<ApiPasswordError>
    ) {
      state.submitting = false;
      state.apiPasswordError = action.payload;
    },
    resetApiPasswordErrors(state: State) {
      state.apiPasswordError = null;
    },
  },
});

/**
 * create actions WITHOUT reducer (pure action) here
 */
export const pureAction = createAction("editPassword/pureAction");

/**
 * actions from slice to be exported for saga
 */
export const {
  loadPasswordPolicies,
  afterPasswordPoliciesLoad,
  submitChangePassword,
  afterApiPasswordError,
  resetApiPasswordErrors,
} = slice.actions;

/**
 * all actions for layout
 */
export const actionProps = createActionDispatchers(
  slice.actions,
  // slice actions
  [
    "loadPasswordPolicies",
    "submitChangePassword",
    "afterApiPasswordError",
    "resetApiPasswordErrors",
  ],
  // pure actions
  {
    pureAction,
    getTnCForCidpUser,
    setUserAcceptedNewTnC,
    goToDashboard: () => push("/dashboard/home"),
    goToSecuritySettings: () => push("/dashboard/securitysettings"),
  }
);

export default slice.reducer;
